<div>
    <div aria-labelledby="contact-tab" class="tab-pane fade" id="contact" role="tabpanel">
        <div class="container-fluid">
            <div class="content-block">
                <div class="error-list" v-if="ui.error.error_message">
                    <ul class="error-msg">
                        <li :key="x" v-for="(error,x) in ui.error.error_message">
                            <div :key="i" v-for="(err,i) in error">
                                <p> {{err}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="form-modified">
                    <div class="row">
                        <div class="col-md-4">
                            <label for="">First name*</label>
                            <div v-if="!ui.status.editProfile">

                                <label class="readonly" for="" v-if="item.userData.firstname">{{item.userData.firstname}}</label>
                                <label class="readonly" for="" v-else>-</label>
                            </div>
                            <div class="form-group" v-else>
                                <input :class="{ 'error-input' : ui.error.errors['first_name'] }" class="form-control" id="inputPassword"
                                       placeholder="First Name" type="text"
                                       v-model="item.userData.firstname"/>
                                <validation-error :errors="ui.error.errors" :field="'first_name'" :isError="ui.error.has_error" v-if="ui.error.has_error"/>
                                <!-- <div class="empty-data">
                               <p>This field is required</p>
                             </div> -->
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label for="">Last name*</label>
                            <div v-if="!ui.status.editProfile">
                                <label class="readonly" for="" v-if="item.userData.lastname">{{item.userData.lastname}}</label>
                                <label class="readonly" for="" v-else>-</label>
                            </div>
                            <div class="form-group" v-else>
                                <input :class="{ 'error-input' : ui.error.errors['last_name'] }" class="form-control" id="inputPassword"
                                       placeholder="Last Name" type="text"
                                       v-model="item.userData.lastname"/>
                                <validation-error :errors="ui.error.errors" :field="'last_name'" :isError="ui.error.has_error" v-if="ui.error.has_error"/>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label for="">Company name*</label>
                            <div v-if="!ui.status.editProfile">
                                <label class="readonly" for="" v-if="item.accountData.company_name">{{item.accountData.company_name}}</label>
                                <label class="readonly" for="" v-else>-</label>
                            </div>
                            <div class="form-group" v-else>
                                <input :class="{ 'error-input' : ui.error.errors['company_name'] }" class="form-control" id="inputPassword"
                                       placeholder="Company Name" type="text"
                                       v-model="item.accountData.company_name"/>
                                <validation-error :errors="ui.error.errors" :field="'company_name'" :isError="ui.error.has_error" v-if="ui.error.has_error"/>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-md-4">
                            <label for="">Company Address Line1</label>
                            <div class="form-group" v-if="!ui.status.editProfile">
                                <label class="readonly" for="" v-if="item.accountData.company_address_line1">{{item.accountData.company_address_line1}}</label>
                                <label class="readonly" for="" v-else>-</label>
                            </div>
                            <div class="form-group" v-else>
                                <input class="form-control" id="inputPassword" placeholder="Company Address Line 1" type="text"
                                       v-model="item.accountData.company_address_line1"/>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <label for="">Company Address Line2</label>
                            <div class="form-group" v-if="!ui.status.editProfile">
                                <label class="readonly" for="" v-if="item.accountData.company_address_line2">{{item.accountData.company_address_line2}}</label>
                                <label class="readonly" for="" v-else>-</label>
                            </div>
                            <div class="form-group" v-else>
                                <input class="form-control" id="inputPassword" placeholder="Company Address Line 2" type="text"
                                       v-model="item.accountData.company_address_line2"/>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <label for="">City</label>
                            <div class="form-group" v-if="!ui.status.editProfile">
                                <label class="readonly" for="" v-if="item.accountData.company_city">{{item.accountData.company_city}}</label>
                                <label class="readonly" for="" v-else>-</label>
                            </div>
                            <div class="form-group" v-else>
                                <input class="form-control" id="inputPassword" placeholder="Company City" type="text"
                                       v-model="item.accountData.company_city"/>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label for="">Province</label>
                            <div class="form-group" v-if="!ui.status.editProfile">
                                <label class="readonly" for="" v-if="item.accountData.company_province">{{item.accountData.company_province}}</label>
                                <label class="readonly" for="" v-else>-</label>
                            </div>
                            <div class="form-group" v-else>
                                <input class="form-control" id="inputPassword" placeholder="Company Province"
                                       type="text" v-model="item.accountData.company_province"/>

                            </div>
                        </div>
                        <div class="col-md-4">
                            <label for="">Country</label>
                            <div class="form-group" v-if="!ui.status.editProfile">
                                <label class="readonly" for="" v-if="item.accountData.company_country">{{item.accountData.company_country}}</label>
                                <label class="readonly" for="" v-else>-</label>
                            </div>
                            <div class="form-group" v-else>
                                <input :class="{ 'error-input' : ui.error.errors['country_name'] }" class="form-control" id="inputPassword" placeholder="Company Country"
                                       type="text" v-model="item.accountData.company_country"/>
                                <validation-error :errors="ui.error.errors" :field="'country_name'" :isError="ui.error.has_error" v-if="ui.error.has_error"/>

                            </div>
                        </div>

                        <div class="col-md-4">
                            <label for="">Zip code</label>
                            <div class="form-group" v-if="!ui.status.editProfile">
                                <label class="readonly" for="" v-if="item.accountData.company_zip">{{item.accountData.company_zip}}</label>
                                <label class="readonly" for="" v-else>-</label>
                            </div>
                            <div class="form-group" v-else>
                                <input :class="{ 'error-input' : ui.error.errors['country_zip'] }" @keypress="preventNonNumericalInput($event)" class="form-control"
                                       id="inputPassword" placeholder="Company Zip" type="text"
                                       v-model="item.accountData.company_zip"/>
                                <validation-error :errors="ui.error.errors" :field="'country_zip'" :isError="ui.error.has_error" v-if="ui.error.has_error"/>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <label for="">Phone 1</label>
                            <div class="form-group" v-if="!ui.status.editProfile">
                                <label class="readonly" for="" v-if="item.accountData.company_phone1">{{item.accountData.company_phone1}}</label>
                                <label class="readonly" for="" v-else>-</label>
                            </div>
                            <div class="form-group" v-else>
                                <input @keypress="preventNonNumericalInput($event)" class="form-control" id="contact1"
                                       placeholder="Company Contact 1" type="text" v-model="item.accountData.company_phone1"/>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label for="">Phone 2</label>
                            <div class="form-group" v-if="!ui.status.editProfile">
                                <label class="readonly" for="" v-if="item.accountData.company_phone2">{{item.accountData.company_phone2}}</label>
                                <label class="readonly" for="" v-else>-</label>
                            </div>
                            <div class="form-group" v-else>
                                <input @keypress="preventNonNumericalInput($event)" class="form-control" id="contact2"
                                       placeholder="Company Contact 2" type="text" v-model="item.accountData.company_phone2"/>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label for="">Contact person</label>
                            <div class="form-group" v-if="!ui.status.editProfile">
                                <label class="readonly" for="" v-if="item.accountData.company_contact_person">{{item.accountData.company_contact_person}}</label>
                                <label class="readonly" for="" v-else>-</label>
                            </div>
                            <div class="form-group" v-else>
                                <input class="form-control" id="text" placeholder="Company Contact Person" type="text"
                                       v-model="item.accountData.company_contact_person"/>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label for="">Contact person designation</label>
                            <div class="form-group" v-if="!ui.status.editProfile">
                                <label class="readonly" for="" v-if="item.accountData.contact_person_designation">{{item.accountData.contact_person_designation}}</label>
                                <label class="readonly" for="" v-else>-</label>
                            </div>
                            <div class="form-group" v-else>
                                <input class="form-control" id="text" placeholder="Company Contact Person" type="text"
                                       v-model="item.accountData.contact_person_designation"/>
                            </div>
                        </div>
                    </div>


                    <div class="form-group">
                        <button @click.prevent="onEditCompanyProfileClick" class="default-btn" type="submit" v-if="!ui.status.editProfile">
                            Edit
                        </button>
                        <button @click.prevent="updateCompanyProfile" class="default-btn save-btn" type="submit" v-if="ui.status.editProfile">
                            Save
                            <spinner :loading="ui.status.postLoading.editProfile" v-if="ui.status.postLoading.editProfile"></spinner>
                        </button>
                        <button @click.prevent="onCancelCompanyProfileClick" class="default-btn cancel" type="submit" v-if="ui.status.editProfile">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
